import { render, staticRenderFns } from "./officialHolidays.vue?vue&type=template&id=4422cfd3&"
import script from "./officialHolidays.vue?vue&type=script&lang=js&"
export * from "./officialHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports